import { render, staticRenderFns } from "./InfoAlert.vue?vue&type=template&id=72ba66d0"
import script from "./InfoAlert.vue?vue&type=script&lang=js"
export * from "./InfoAlert.vue?vue&type=script&lang=js"
import style0 from "./InfoAlert.vue?vue&type=style&index=0&id=72ba66d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports